const isProd = process.env.NODE_ENV === "production";

export const logDev = (...args) => {
  if (!isProd) {
    console.log(...args);
  }
};

export const warnDev = (...args) => {
  if (!isProd) {
    console.warn(...args);
  }
};

export const errorDev = (...args) => {
  if (!isProd) {
    console.error(...args);
  }
};
